/*
 * DELUXY OPZIONI — le personalizzazioni del prodotto (scritta, candeline, foto, gusti…).
 * Sostituisce l'app «VO Product Options» (metafield `bcpo.bcpo_data`).
 *
 * La configurazione sta nel metafield di prodotto `deluxy.opzioni` (JSON, formato v1):
 *   { v: 1, opzioni: [ { id, codice?, tipo, nome:{it,en,…}, aiuto?, obbligatoria?, min?, max?,
 *                        multipla?, aspetto?, valori?:[{id, nome, immagine?, colore?, prezzo?}],
 *                        prezzo?, mostraSe?, oraLimiteOggi?, maxParole?, maxParoleSe? } ] }
 *   tipo     testo | testo_lungo | numero | scelta | foto
 *   oraLimiteOggi  (25/10/2026) l'ora intera 0–23, ora di Roma, entro cui si può chiedere questa
 *            personalizzazione PER UNA CONSEGNA IN GIORNATA («scritta sulla torta: per oggi entro le 13»).
 *            Sotto il nome compare «Per oggi entro le 13:00»; se la data di consegna scelta è oggi e l'ora è
 *            passata, il campo si spegne e l'invio si ferma («scegli la consegna da domani»). Senza data
 *            scelta (`opzioni.dataConsegna` assente o vuota) si avvisa soltanto. Per gli altri giorni non conta.
 *   maxParole   (27/10/2026, solo testo) quante parole al massimo; con `maxParoleSe` (una condizione, come mostraSe)
 *            vale solo quando la condizione è vera. Nicolò: «sulle torte piccole come scritta non più di tre parole,
 *            non frasi: non ci entrano perché le torte hanno già il loro decoro» → { maxParole: 3,
 *            maxParoleSe: { variante: true, op: 'minore', valore: 9 } } = fino a 8 persone.
 *   aspetto  (solo scelta) pulsanti | tendina | immagini | colori
 *   prezzo   { variante, sku?, importo, per?, perPezzo? } — il plus a pagamento è un PRODOTTO VERO
 *            (variante Shopify con SKU `PLUS-…`) aggiunto al carrello come riga collegata:
 *              per       fisso (1) | valore (il numero scritto) | foto (quante foto) | variante (il numero
 *                        nel nome della variante scelta: «6» porzioni → 6)
 *              perPezzo  true (predefinito): si moltiplica anche per la quantità del prodotto
 *   mostraSe { tutte:[…] } | { almeno:[…] } | clausola
 *            clausola: { opzione:id | variante:true | quantita:true, op, valore? }
 *            op: uguale | diverso | compilata | vuota | maggiore | minore | contiene
 *            sulla variante, maggiore/minore guardano il PRIMO NUMERO del titolo («6/8» → 6, «10 / Cioccolato» → 10)
 *
 * Le CHIAVI delle proprietà della riga sono neutre (29/10/2026, Nicolò: al checkout di Shopify si vedono così come
 * sono, in ogni lingua): il nome INGLESE dell'opzione (`nome.en`, e l'italiano se manca), per esempio «Message on the
 * cake», «Number for the candle», «Photo 1»; il legame del plus con la torta è «For: <titolo>». Nel carrello e nel cassetto
 * del tema si mostrano nella lingua della pagina (deluxy-proprieta-lingua); Orders, Customer Service e la piattaforma le
 * leggono come testo generico («Nome: valore»), la piattaforma accetta «Per:» e «For:». Prima del 29/10 erano in
 * italiano: le righe vecchie nel carrello si riconoscono da tutti e due i nomi. Le proprietà che iniziano con «_» sono
 * tecniche: `_plus_id` sulla riga madre, `_plus_di` sulle righe dei plus.
 *
 * La prima metà del file è logica pura (provata con `node --test`), la seconda è il montaggio a schermo.
 */
(function (radice, fabbrica) {
  var api = fabbrica();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else radice.DeluxyOpzioni = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // ───────────────────────── logica pura ─────────────────────────

  var MESSAGGI = {
    it: { obbligatoria: 'Campo obbligatorio', min_scelte: 'Scegli almeno {n}', max_scelte: 'Scegli al massimo {n}',
      min_numero: 'Il minimo è {n}', max_numero: 'Il massimo è {n}', max_testo: 'Al massimo {n} caratteri', max_parole: 'Parole: massimo {n}',
      min_foto: 'Carica almeno {n} foto', max_foto: 'Al massimo {n} foto', foto_scartata: 'Foto non aggiunta: al massimo {n}', numero: 'Scrivi un numero',
      scegli: 'Scegli', aggiungi_foto: 'Aggiungi foto', togli: 'Togli', totale: 'Personalizzazioni',
      foto_tipo: 'Solo immagini (JPG, PNG, WEBP, HEIC)', foto_peso: 'Ogni foto al massimo {n} MB', errore_carrello: 'Non siamo riusciti ad aggiungere al carrello. Riprova.',
      plus_non_disponibile: 'Una personalizzazione scelta al momento non si può aggiungere al carrello: la tolga per procedere, oppure ci contatti.',
      invio: 'Aggiunta al carrello in corso…', l_una: "l'una", a_porzione: 'a porzione', max_breve: 'max {n}', intero: 'Scrivi un numero intero',
      ora_limite: 'Per oggi entro le {n} (ora italiana)', fuori_orario: 'Per oggi non più disponibile (entro le {n}, ora italiana): scegli la consegna da domani' },
    en: { obbligatoria: 'Required', min_scelte: 'Choose at least {n}', max_scelte: 'Choose up to {n}',
      min_numero: 'Minimum is {n}', max_numero: 'Maximum is {n}', max_testo: 'Up to {n} characters', max_parole: 'Words: up to {n}',
      min_foto: 'Upload at least {n} photos', max_foto: 'Up to {n} photos', foto_scartata: 'Photo not added: up to {n}', numero: 'Enter a number',
      scegli: 'Choose', aggiungi_foto: 'Add photos', togli: 'Remove', totale: 'Customisations',
      foto_tipo: 'Images only (JPG, PNG, WEBP, HEIC)', foto_peso: 'Each photo up to {n} MB', errore_carrello: 'We could not add to cart. Please try again.',
      plus_non_disponibile: 'A selected personalisation cannot be added to the cart right now: remove it to continue, or contact us.',
      invio: 'Adding to cart…', l_una: 'each', a_porzione: 'per serving', max_breve: 'max {n}', intero: 'Enter a whole number',
      ora_limite: 'For today, order by {n} (Italian time)', fuori_orario: 'No longer available for today (order by {n}, Italian time): choose delivery from tomorrow' },
    ru: { obbligatoria: 'Обязательное поле', min_scelte: 'Выберите не менее {n}', max_scelte: 'Выберите не более {n}',
      min_numero: 'Минимум {n}', max_numero: 'Максимум {n}', max_testo: 'Не более {n} символов', max_parole: 'Слов: не более {n}',
      min_foto: 'Загрузите не менее {n} фото', max_foto: 'Не более {n} фото', foto_scartata: 'Фото не добавлено: не более {n}', numero: 'Введите число',
      scegli: 'Выберите', aggiungi_foto: 'Добавить фото', togli: 'Удалить', totale: 'Персонализация',
      foto_tipo: 'Только изображения (JPG, PNG, WEBP, HEIC)', foto_peso: 'Каждое фото до {n} МБ', errore_carrello: 'Не удалось добавить в корзину. Попробуйте ещё раз.',
      plus_non_disponibile: 'Выбранную персонализацию сейчас нельзя добавить в корзину: уберите её, чтобы продолжить, или свяжитесь с нами.',
      invio: 'Добавляем в корзину…', l_una: 'за шт.', a_porzione: 'за порцию', max_breve: 'макс. {n}', intero: 'Введите целое число',
      ora_limite: 'На сегодня — заказ до {n} (по времени Италии)', fuori_orario: 'На сегодня больше недоступно (заказ до {n}, по времени Италии): выберите доставку с завтрашнего дня' },
    // 03/11/2026 (Nicolò: «tutto deve essere nella lingua dell'utente se è disponibile sul sito»): le altre lingue del sito.
    // `pt` è il portoghese del Portogallo; /pt dà `pt-BR`, che `lingua2` porta a `pt`.
    es: { obbligatoria: 'Campo obligatorio', min_scelte: 'Elija al menos {n}', max_scelte: 'Elija como máximo {n}',
      min_numero: 'El mínimo es {n}', max_numero: 'El máximo es {n}', max_testo: 'Máximo {n} caracteres', max_parole: 'Palabras: máximo {n}',
      min_foto: 'Fotos: mínimo {n}', max_foto: 'Fotos: máximo {n}', foto_scartata: 'Foto no añadida: máximo {n}', numero: 'Introduzca un número',
      scegli: 'Elija', aggiungi_foto: 'Añadir fotos', togli: 'Quitar', totale: 'Personalizaciones',
      foto_tipo: 'Solo imágenes (JPG, PNG, WEBP, HEIC)', foto_peso: 'Máximo {n} MB por foto', errore_carrello: 'No hemos podido añadirlo al carrito. Inténtelo de nuevo.',
      plus_non_disponibile: 'Una de las personalizaciones elegidas no se puede añadir al carrito en este momento: quítela para continuar o póngase en contacto con nosotros.',
      invio: 'Añadiendo al carrito…', l_una: 'por unidad', a_porzione: 'por ración', max_breve: 'máx. {n}', intero: 'Introduzca un número entero',
      ora_limite: 'Para hoy, pida hasta las {n} (hora de Italia)', fuori_orario: 'Ya no está disponible para hoy (hasta las {n}, hora de Italia): elija la entrega a partir de mañana' },
    fr: { obbligatoria: 'Champ obligatoire', min_scelte: 'Choisissez au moins {n}', max_scelte: 'Choisissez au maximum {n}',
      min_numero: 'Le minimum est de {n}', max_numero: 'Le maximum est de {n}', max_testo: '{n} caractères maximum', max_parole: 'Mots : {n} maximum',
      min_foto: 'Photos : {n} minimum', max_foto: 'Photos : {n} maximum', foto_scartata: 'Photo non ajoutée : {n} maximum', numero: 'Saisissez un nombre',
      scegli: 'Choisissez', aggiungi_foto: 'Ajouter des photos', togli: 'Retirer', totale: 'Personnalisations',
      foto_tipo: 'Images uniquement (JPG, PNG, WEBP, HEIC)', foto_peso: '{n} Mo maximum par photo', errore_carrello: "Nous n'avons pas pu l'ajouter au panier. Veuillez réessayer.",
      plus_non_disponibile: 'Une personnalisation choisie ne peut pas être ajoutée au panier pour le moment : retirez-la pour continuer ou contactez-nous.',
      invio: 'Ajout au panier en cours…', l_una: "l'unité", a_porzione: 'par part', max_breve: '{n} max.', intero: 'Saisissez un nombre entier',
      ora_limite: "Pour aujourd'hui, commandez au plus tard à {n} (heure italienne)", fuori_orario: "Plus disponible pour aujourd'hui (commande au plus tard à {n}, heure italienne) : choisissez une livraison à partir de demain" },
    de: { obbligatoria: 'Pflichtfeld', min_scelte: 'Wählen Sie mindestens {n}', max_scelte: 'Wählen Sie höchstens {n}',
      min_numero: 'Mindestwert: {n}', max_numero: 'Höchstwert: {n}', max_testo: 'Höchstens {n} Zeichen', max_parole: 'Wörter: höchstens {n}',
      min_foto: 'Fotos: mindestens {n}', max_foto: 'Fotos: höchstens {n}', foto_scartata: 'Foto nicht hinzugefügt: höchstens {n}', numero: 'Geben Sie eine Zahl ein',
      scegli: 'Bitte wählen', aggiungi_foto: 'Fotos hinzufügen', togli: 'Entfernen', totale: 'Personalisierungen',
      foto_tipo: 'Nur Bilder (JPG, PNG, WEBP, HEIC)', foto_peso: 'Höchstens {n} MB pro Foto', errore_carrello: 'Das Hinzufügen zum Warenkorb ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
      plus_non_disponibile: 'Eine gewählte Personalisierung kann derzeit nicht in den Warenkorb gelegt werden: Entfernen Sie sie, um fortzufahren, oder kontaktieren Sie uns.',
      invio: 'Wird in den Warenkorb gelegt…', l_una: 'pro Stück', a_porzione: 'pro Portion', max_breve: 'max. {n}', intero: 'Geben Sie eine ganze Zahl ein',
      ora_limite: 'Für heute bis {n} Uhr bestellen (italienische Zeit)', fuori_orario: 'Für heute nicht mehr verfügbar (Bestellung bis {n} Uhr, italienische Zeit): Wählen Sie eine Lieferung ab morgen' },
    pt: { obbligatoria: 'Campo obrigatório', min_scelte: 'Escolha pelo menos {n}', max_scelte: 'Escolha no máximo {n}',
      min_numero: 'O mínimo é {n}', max_numero: 'O máximo é {n}', max_testo: 'No máximo {n} caracteres', max_parole: 'Palavras: no máximo {n}',
      min_foto: 'Fotos: no mínimo {n}', max_foto: 'Fotos: no máximo {n}', foto_scartata: 'Foto não adicionada: no máximo {n}', numero: 'Introduza um número',
      scegli: 'Escolha', aggiungi_foto: 'Adicionar fotos', togli: 'Remover', totale: 'Personalizações',
      foto_tipo: 'Apenas imagens (JPG, PNG, WEBP, HEIC)', foto_peso: 'No máximo {n} MB por foto', errore_carrello: 'Não foi possível adicionar ao carrinho. Tente novamente.',
      plus_non_disponibile: 'Uma das personalizações escolhidas não pode ser adicionada ao carrinho neste momento: retire-a para continuar ou contacte-nos.',
      invio: 'A adicionar ao carrinho…', l_una: 'cada', a_porzione: 'por porção', max_breve: 'máx. {n}', intero: 'Introduza um número inteiro',
      ora_limite: 'Para hoje, encomende até às {n} (hora de Itália)', fuori_orario: 'Já não está disponível para hoje (até às {n}, hora de Itália): escolha a entrega a partir de amanhã' },
    tr: { obbligatoria: 'Zorunlu alan', min_scelte: 'En az {n} seçenek seçin', max_scelte: 'En fazla {n} seçenek seçin',
      min_numero: 'En düşük değer: {n}', max_numero: 'En yüksek değer: {n}', max_testo: 'En fazla {n} karakter', max_parole: 'Kelime sayısı: en fazla {n}',
      min_foto: 'En az {n} fotoğraf yükleyin', max_foto: 'En fazla {n} fotoğraf', foto_scartata: 'Fotoğraf eklenmedi: en fazla {n}', numero: 'Bir sayı girin',
      scegli: 'Seçin', aggiungi_foto: 'Fotoğraf ekle', togli: 'Kaldır', totale: 'Kişiselleştirmeler',
      foto_tipo: 'Yalnızca görseller (JPG, PNG, WEBP, HEIC)', foto_peso: 'Fotoğraf başına en fazla {n} MB', errore_carrello: 'Sepete eklenemedi. Lütfen tekrar deneyin.',
      plus_non_disponibile: 'Seçtiğiniz kişiselleştirmelerden biri şu anda sepete eklenemiyor: devam etmek için kaldırın veya bizimle iletişime geçin.',
      invio: 'Sepete ekleniyor…', l_una: 'adet başına', a_porzione: 'porsiyon başına', max_breve: 'en fazla {n}', intero: 'Bir tam sayı girin',
      ora_limite: 'Bugün teslimat için son sipariş saati: {n} (İtalya saati)', fuori_orario: 'Bugün için artık mümkün değil (son sipariş saati {n}, İtalya saati): yarından itibaren bir teslimat tarihi seçin' },
    ar: { obbligatoria: 'حقل إلزامي', min_scelte: 'يُرجى اختيار {n} على الأقل', max_scelte: 'يُرجى اختيار {n} كحدٍّ أقصى',
      min_numero: 'الحد الأدنى {n}', max_numero: 'الحد الأقصى {n}', max_testo: 'الحد الأقصى لعدد الأحرف: {n}', max_parole: 'الحد الأقصى لعدد الكلمات: {n}',
      min_foto: 'الحد الأدنى لعدد الصور: {n}', max_foto: 'الحد الأقصى لعدد الصور: {n}', foto_scartata: 'لم تتم إضافة الصورة: الحد الأقصى {n}', numero: 'يُرجى إدخال رقم',
      scegli: 'اختر', aggiungi_foto: 'إضافة صور', togli: 'إزالة', totale: 'التخصيصات',
      foto_tipo: 'الصور فقط (JPG، PNG، WEBP، HEIC)', foto_peso: 'الحد الأقصى لحجم كل صورة {n} ميغابايت', errore_carrello: 'تعذّرت الإضافة إلى السلة. يُرجى المحاولة مرة أخرى.',
      plus_non_disponibile: 'لا يمكن حاليًا إضافة أحد التخصيصات المختارة إلى السلة: يُرجى إزالته للمتابعة أو التواصل معنا.',
      invio: 'جارٍ الإضافة إلى السلة…', l_una: 'للقطعة الواحدة', a_porzione: 'للحصة الواحدة', max_breve: 'بحدٍّ أقصى {n}', intero: 'يُرجى إدخال عدد صحيح',
      ora_limite: 'للتوصيل اليوم: آخر موعد للطلب الساعة {n} (بتوقيت إيطاليا)', fuori_orario: 'لم يعد متاحًا لليوم (آخر موعد للطلب الساعة {n} بتوقيت إيطاليا): يُرجى اختيار التوصيل ابتداءً من الغد' },
  };

  function lingua2(lingua) { return String(lingua || 'it').toLowerCase().slice(0, 2); }

  /**
   * Il testo nella lingua chiesta; se manca, inglese per chi non è italiano, poi italiano.
   * 03/11/2026: prima si cerca il codice COMPLETO (`pt-BR`, senza badare alle maiuscole: l'editor di Merchandising scrive
   * il codice del negozio e `Shopify.locale` su /pt lo dà uguale), poi le sue prime due lettere (`pt`).
   */
  function testo(mappa, lingua) {
    if (mappa == null) return '';
    if (typeof mappa === 'string') return mappa;
    var l = lingua2(lingua);
    var piena = String(lingua || 'it').toLowerCase().replace(/_/g, '-');
    if (piena !== l) {
      for (var k in mappa) if (Object.prototype.hasOwnProperty.call(mappa, k) && mappa[k] && k.toLowerCase() === piena) return mappa[k];
    }
    return mappa[l] || (l !== 'it' && mappa.en) || mappa.it || '';
  }

  function messaggio(chiave, lingua, n) {
    var l = lingua2(lingua);
    var m = (MESSAGGI[l] || MESSAGGI.en)[chiave] || MESSAGGI.it[chiave] || chiave;
    return m.replace('{n}', n);
  }

  function vuoto(v) {
    if (v == null) return true;
    if (Array.isArray(v)) return v.length === 0;
    if (typeof v === 'number') return !(v > 0);
    return String(v).trim() === '';
  }

  function opzioneDi(config, id) {
    var lista = (config && config.opzioni) || [];
    for (var i = 0; i < lista.length; i++) if (lista[i].id === id) return lista[i];
    return null;
  }

  /**
   * Cifre arabo-indiche (٠–٩) e persiane (۰–۹) in cifre latine, e la virgola decimale araba «٫» in punto.
   * 03/11/2026: su /ar i titoli delle varianti escono «٤/٦», «٦/٨»: senza questo passaggio `numeroIn` non trovava
   * nessun numero, la condizione «fino a 8 persone» era falsa (via il limite delle 3 parole) e il plus «a porzione»
   * contava 1 porzione.
   */
  function cifreLatine(t) {
    return String(t == null ? '' : t).replace(/[٠-٩۰-۹٫]/g, function (c) {
      if (c === '٫') return '.';
      var codice = c.charCodeAt(0);
      return String(codice - (codice >= 0x06F0 ? 0x06F0 : 0x0660));
    });
  }

  /** Il primo numero scritto in un testo: «6» → 6, «4/6» → 4, «Large 400g» → 400, «٦/٨» → 6, «M» → null. */
  function numeroIn(t) {
    var m = cifreLatine(t).match(/\d+(?:[.,]\d+)?/);
    return m ? Number(m[0].replace(',', '.')) : null;
  }

  function confronta(attuale, op, atteso) {
    switch (op) {
      case 'compilata': return !vuoto(attuale);
      case 'vuota': return vuoto(attuale);
      case 'maggiore': return Number(attuale) > Number(atteso);
      case 'minore': return !vuoto(attuale) && Number(attuale) < Number(atteso);
      case 'contiene':
        if (Array.isArray(attuale)) return attuale.indexOf(atteso) >= 0;
        return String(attuale == null ? '' : attuale).toLowerCase().indexOf(String(atteso).toLowerCase()) >= 0;
      case 'diverso': return !confronta(attuale, 'uguale', atteso);
      default: // uguale
        if (Array.isArray(attuale)) return attuale.length === 1 && attuale[0] === atteso;
        return String(attuale == null ? '' : attuale).trim().toLowerCase() === String(atteso == null ? '' : atteso).trim().toLowerCase();
    }
  }

  /** Una condizione è vera? `visti` ferma i cicli (A dipende da B che dipende da A = nascosta). */
  function vera(cond, config, stato, visti) {
    if (!cond) return true;
    if (Array.isArray(cond.tutte)) return cond.tutte.every(function (c) { return vera(c, config, stato, visti); });
    if (Array.isArray(cond.almeno)) return cond.almeno.some(function (c) { return vera(c, config, stato, visti); });
    if (cond.variante) {
      // «M / Si» è la variante di due opzioni Shopify: «uguale a M» guarda ogni parte, non il titolo intero.
      var titolo = cifreLatine((stato.variante && stato.variante.titolo) || '');
      if (cond.op === 'uguale' || cond.op === 'diverso' || !cond.op) {
        var combacia = titolo.split(' / ').some(function (parte) { return confronta(parte, 'uguale', cond.valore); });
        return cond.op === 'diverso' ? !combacia : combacia;
      }
      // 27/10/2026: «6/8 persone» non è un numero; per maggiore/minore vale il primo numero del titolo.
      if (cond.op === 'maggiore' || cond.op === 'minore') {
        var numero = numeroIn(titolo);
        return numero != null && confronta(numero, cond.op, cond.valore);
      }
      return confronta(titolo, cond.op, cond.valore);
    }
    if (cond.quantita) return confronta(Math.max(1, Number(stato.quantita) || 1), cond.op, cond.valore);
    var o = opzioneDi(config, cond.opzione);
    // Un'opzione che non esiste o che è nascosta vale come vuota: le condizioni vanno a cascata.
    var valore = o && visibileConVisti(o, config, stato, visti) ? (stato.valori || {})[o.id] : null;
    return confronta(valore, cond.op, cond.valore);
  }

  function visibileConVisti(opzione, config, stato, visti) {
    if (!opzione.mostraSe) return true;
    visti = visti || [];
    if (visti.indexOf(opzione.id) >= 0) return false;
    return vera(opzione.mostraSe, config, stato, visti.concat(opzione.id));
  }

  /** L'opzione si vede, con le scelte fatte finora? */
  function visibile(opzione, config, stato) { return visibileConVisti(opzione, config, stato || {}, []); }

  function comeLista(v) { return Array.isArray(v) ? v : vuoto(v) ? [] : [v]; }

  /** La CHIAVE neutra di un'opzione o di un valore: il nome inglese, altrimenti l'italiano (29/10/2026). */
  function chiave(mappa) { return testo(mappa, 'en'); }
  /** Una chiave letta dal carrello corrisponde a questo nome? Vale la chiave nuova (en) e quella vecchia (it). */
  function stessaChiave(k, mappa) { k = String(k == null ? '' : k).trim(); return k !== '' && (k === chiave(mappa) || k === testo(mappa, 'it')); }

  // ───── l'ora limite per la consegna in giornata (25/10/2026) ─────

  /** L'ora limite dell'opzione, se è scritta bene (intero 0–23); altrimenti null. */
  function oraLimite(o) {
    var n = o && o.oraLimiteOggi;
    return typeof n === 'number' && n === Math.floor(n) && n >= 0 && n <= 23 ? n : null;
  }

  /** «13» → «13:00». */
  function etichettaOra(n) { return (n < 10 ? '0' : '') + n + ':00'; }

  /** Adesso a Roma: { data: 'AAAA-MM-GG', minuti: minuti dalla mezzanotte }. Il fuso è quello del laboratorio, non del cliente. */
  function oraRomaAdesso(quando) {
    var d = quando || new Date();
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(d)
        .forEach(function (x) { p[x.type] = x.value; });
      return { data: p.year + '-' + p.month + '-' + p.day, minuti: (Number(p.hour) % 24) * 60 + Number(p.minute) };
    } catch (e) {
      // Browser senza fusi: l'orologio del dispositivo, meglio di niente.
      var mm = d.getMonth() + 1, gg = d.getDate();
      return { data: d.getFullYear() + '-' + (mm < 10 ? '0' : '') + mm + '-' + (gg < 10 ? '0' : '') + gg, minuti: d.getHours() * 60 + d.getMinutes() };
    }
  }

  /**
   * L'opzione è fuori orario per oggi? Solo se ha un'ora limite, la data di consegna scelta è OGGI (a Roma) e
   * l'ora è passata. `stato.dataConsegna` è 'AAAA-MM-GG' (o vuota = non si sa: allora non si ferma nessuno),
   * `stato.adesso` è { data, minuti } (predefinito: l'orologio, a Roma).
   */
  function fuoriOrario(o, stato) {
    var limite = oraLimite(o);
    if (limite == null) return false;
    stato = stato || {};
    var data = stato.dataConsegna ? String(stato.dataConsegna).slice(0, 10) : '';
    if (!data) return false;
    var adesso = stato.adesso || oraRomaAdesso();
    return data === adesso.data && adesso.minuti >= limite * 60;
  }

  /** Le parole di un testo: separate da spazi, a capo o tabulazioni. */
  function parole(v) {
    return String(v == null ? '' : v).trim().split(/\s+/).filter(Boolean).length;
  }

  /** Gli errori di compilazione delle opzioni visibili: [{ id, messaggio }]. */
  function valida(config, stato, lingua) {
    var errori = [];
    stato = stato || {};
    ((config && config.opzioni) || []).forEach(function (o) {
      if (!visibile(o, config, stato)) return;
      var v = (stato.valori || {})[o.id];
      var err = function (chiave, n) { errori.push({ id: o.id, messaggio: messaggio(chiave, lingua, n) }); };
      // Oggi non si può più: con qualcosa di scritto (o se è obbligatoria) l'ordine per oggi si ferma.
      if (fuoriOrario(o, stato) && (!vuoto(v) || o.obbligatoria)) return err('fuori_orario', etichettaOra(oraLimite(o)));
      if (o.tipo === 'foto') {
        var n = Number(v) || 0;
        var minimo = o.min != null ? o.min : o.obbligatoria ? 1 : 0;
        if (n < minimo) return err(minimo > 1 ? 'min_foto' : 'obbligatoria', minimo);
        if (o.max != null && n > o.max) return err('max_foto', o.max);
        return;
      }
      if (o.tipo === 'scelta' && o.multipla) {
        var scelte = comeLista(v);
        var min = o.min != null ? o.min : o.obbligatoria ? 1 : 0;
        if (scelte.length < min) return err(min > 1 ? 'min_scelte' : 'obbligatoria', min);
        if (o.max != null && scelte.length > o.max) return err('max_scelte', o.max);
        return;
      }
      if (vuoto(v)) { if (o.obbligatoria) err('obbligatoria'); return; }
      if (o.tipo === 'numero') {
        if (!/^\d+$/.test(String(v).trim())) return err(/^\d+[.,]\d+$/.test(String(v).trim()) ? 'intero' : 'numero');
        var num = Number(String(v).trim());
        if (o.min != null && num < o.min) return err('min_numero', o.min);
        if (o.max != null && num > o.max) return err('max_numero', o.max);
      }
      if ((o.tipo === 'testo' || o.tipo === 'testo_lungo') && o.max != null && String(v).length > o.max) return err('max_testo', o.max);
      if ((o.tipo === 'testo' || o.tipo === 'testo_lungo') && o.maxParole != null && (!o.maxParoleSe || vera(o.maxParoleSe, config, stato, [o.id])) && parole(v) > o.maxParole) err('max_parole', o.maxParole);
    });
    return errori;
  }

  /** Quante unità del plus: il MOLTIPLICATORE fra quantità e prezzo. */
  function unitaPlus(prezzo, valore, stato) {
    var pezzi = prezzo.perPezzo === false ? 1 : Math.max(1, Math.round(Number(stato.quantita) || 1));
    var fattore = 1;
    if (prezzo.per === 'valore') fattore = Math.max(0, Math.round(Number(String(valore).replace(',', '.')) || 0));
    else if (prezzo.per === 'foto') fattore = Math.max(0, Number(valore) || 0);
    else if (prezzo.per === 'variante') fattore = numeroIn(stato.variante && stato.variante.titolo) || 1;
    return fattore * pezzi;
  }

  /**
   * Cosa finisce nel carrello: le proprietà della riga (chiavi in inglese dal 29/10) e le righe dei plus a pagamento,
   * già sommate per variante. Le foto non stanno nelle proprietà: le porta il modulo, come file.
   */
  function calcola(config, stato) {
    stato = stato || {};
    var proprieta = [];
    var perVariante = {};
    var ordine = [];
    var aggiungi = function (prezzo, o, etichetta, valore) {
      if (!prezzo || !(Number(prezzo.importo) > 0)) return;
      var unita = unitaPlus(prezzo, valore, stato);
      if (!(unita > 0)) return;
      var chiave = String(prezzo.variante != null ? prezzo.variante : 'sku:' + prezzo.sku);
      if (!perVariante[chiave]) {
        perVariante[chiave] = { variante: prezzo.variante != null ? prezzo.variante : null, sku: prezzo.sku || null, codice: o.codice || o.id, importo: Number(prezzo.importo), quantita: 0, voci: [] };
        ordine.push(chiave);
      }
      perVariante[chiave].quantita += unita;
      perVariante[chiave].voci.push(etichetta);
    };
    ((config && config.opzioni) || []).forEach(function (o) {
      if (!visibile(o, config, stato)) return;
      var v = (stato.valori || {})[o.id];
      var nome = chiave(o.nome);
      if (o.tipo === 'foto') {
        if (Number(v) > 0) aggiungi(o.prezzo, o, nome + ': ' + v, v);
        return;
      }
      if (vuoto(v)) return;
      if (o.tipo === 'scelta') {
        var nomi = [];
        comeLista(v).forEach(function (id) {
          var val = (o.valori || []).filter(function (x) { return x.id === id; })[0];
          if (!val) return;
          var n = chiave(val.nome);
          nomi.push(n);
          aggiungi(val.prezzo, o, nome + ': ' + n, 1);
        });
        if (!nomi.length) return;
        proprieta.push([nome, nomi.join(', ')]);
        aggiungi(o.prezzo, o, nome + ': ' + nomi.join(', '), nomi.length);
        return;
      }
      var scritto = String(v).trim();
      proprieta.push([nome, scritto]);
      aggiungi(o.prezzo, o, nome + ': ' + scritto, scritto);
    });
    var plus = ordine.map(function (k) { return perVariante[k]; });
    var totale = plus.reduce(function (s, p) { return s + p.importo * p.quantita; }, 0);
    return { proprieta: proprieta, plus: plus, totale: Math.round(totale * 100) / 100 };
  }

  /** I difetti di una configurazione, prima di pubblicarla: [testo]. Vuoto = pubblicabile. */
  function difetti(config) {
    var d = [];
    var ids = Object.create(null); // un id «constructor» non deve sembrare ripetuto
    var lista = (config && config.opzioni) || [];
    if (!config || config.v !== 1) d.push('versione del formato sconosciuta');
    var controllaCond = function (c, o) {
      if (!c) return;
      (c.tutte || c.almeno || []).forEach(function (x) { controllaCond(x, o); });
      if (c.opzione && !opzioneDi(config, c.opzione)) d.push(o.id + ': la condizione cita «' + c.opzione + '», che non esiste');
      if (c.opzione === o.id) d.push(o.id + ': la condizione cita se stessa');
    };
    var controllaPrezzo = function (p, dove) {
      if (!p) return;
      if (!(Number(p.importo) > 0)) d.push(dove + ': prezzo senza importo');
      if (p.variante == null) d.push(dove + ': prezzo senza la variante del plus (SKU ' + (p.sku || '?') + ' non ancora sul negozio)');
    };
    lista.forEach(function (o) {
      if (!o.id) d.push('opzione senza id');
      if (ids[o.id]) d.push(o.id + ': id ripetuto');
      ids[o.id] = true;
      if (['testo', 'testo_lungo', 'numero', 'scelta', 'foto'].indexOf(o.tipo) < 0) d.push(o.id + ': tipo «' + o.tipo + '» sconosciuto');
      if (!testo(o.nome, 'it')) d.push(o.id + ': manca il nome in italiano');
      if (o.tipo === 'scelta' && !(o.valori || []).length) d.push(o.id + ': scelta senza valori');
      if (o.maxParole != null && !(Number.isInteger(o.maxParole) && o.maxParole >= 1 && o.maxParole <= 50)) d.push(o.id + ': massimo di parole «' + o.maxParole + '» non valido (serve un intero 1–50)');
      if (o.maxParole != null && o.tipo !== 'testo' && o.tipo !== 'testo_lungo') d.push(o.id + ': il massimo di parole vale solo per i testi');
      controllaCond(o.maxParoleSe, o);
      if (o.oraLimiteOggi != null && oraLimite(o) == null) d.push(o.id + ': ora limite «' + o.oraLimiteOggi + '» non valida (serve un intero 0–23)');
      (o.valori || []).forEach(function (v) {
        if (v.colore && !coloreAmmesso(v.colore)) d.push(o.id + ' › ' + v.id + ': colore non valido (serve #rrggbb)');
        if (v.immagine && !immagineAmmessa(v.immagine)) d.push(o.id + ' › ' + v.id + ': immagine fuori dal negozio (va caricata sui file di Shopify)');
      });
      controllaCond(o.mostraSe, o);
      controllaPrezzo(o.prezzo, o.id);
      (o.valori || []).forEach(function (v) { controllaPrezzo(v.prezzo, o.id + ' › ' + v.id); });
    });
    // Due opzioni con lo stesso nome italiano si sovrascriverebbero nelle proprietà della riga.
    var nomi = Object.create(null);
    lista.forEach(function (o) {
      var n = testo(o.nome, 'it').toLowerCase();
      if (n && nomi[n]) d.push(o.id + ': stesso nome di «' + nomi[n] + '» (le proprietà della riga si sovrascrivono)');
      nomi[n] = o.id;
    });
    return d;
  }

  // Il metafield lo scrive lo staff, ma il widget non si fida della forma: un colore è un esadecimale, un'immagine
  // sta sul CDN del negozio. Altro non si disegna (niente `url(...)` né richieste a terzi dal browser del cliente).
  function coloreAmmesso(c) { return /^#[0-9a-f]{3,8}$/i.test(String(c)); }
  function immagineAmmessa(u) { return /^https:\/\/(cdn\.shopify\.com|(www\.)?deluxy\.it\/cdn)\//i.test(String(u)); }

  /** Le righe di plus rimaste nel carrello senza la loro riga madre: [{ key }] da togliere. */
  function orfane(carrello) {
    var righe = (carrello && carrello.items) || [];
    var madri = {};
    righe.forEach(function (r) { var id = r.properties && r.properties._plus_id; if (id) madri[id] = true; });
    return righe.filter(function (r) { var di = r.properties && r.properties._plus_di; return di && !madri[di]; })
      .map(function (r) { return { key: r.key }; });
  }

  /**
   * 27/10/2026 — i plus a pagamento scelti che sul negozio NON hanno la variante (`variante` null: lo SKU PLUS-… non esiste
   * o il prodotto non è attivo quando si è pubblicato il metafield). Con anche uno solo l'acquisto si ferma: senza, la madre
   * entrava nel carrello e la riga del plus no (o falliva e si ripuliva), e il cliente poteva pagare la torta senza la scritta.
   */
  function plusSenzaVariante(esito) {
    return ((esito && esito.plus) || []).filter(function (p) { return p.variante == null || p.variante === ''; });
  }

  var puro = { coloreAmmesso: coloreAmmesso, immagineAmmessa: immagineAmmessa, testo: testo, visibile: visibile, valida: valida, calcola: calcola, difetti: difetti, orfane: orfane, numeroIn: numeroIn, messaggio: messaggio, MESSAGGI: MESSAGGI,
    oraLimite: oraLimite, etichettaOra: etichettaOra, oraRomaAdesso: oraRomaAdesso, fuoriOrario: fuoriOrario, plusSenzaVariante: plusSenzaVariante, parole: parole };
  if (typeof document === 'undefined') return puro;

  // ───────────────────────── a schermo ─────────────────────────

  var PESO_MAX_MB = 20;

  function el(tag, attributi, figli) {
    var e = document.createElement(tag);
    Object.keys(attributi || {}).forEach(function (k) {
      if (k === 'class') e.className = attributi[k];
      else if (k === 'text') e.textContent = attributi[k];
      else if (attributi[k] != null && attributi[k] !== false) e.setAttribute(k, attributi[k] === true ? '' : attributi[k]);
    });
    (figli || []).forEach(function (f) { if (f) e.appendChild(f); });
    return e;
  }

  function denaro(importo) {
    var S = window.Shopify || {};
    var valuta = (S.currency && S.currency.active) || 'EUR';
    var cambio = (S.currency && Number(S.currency.rate)) || 1;
    var cifra = Math.round(importo * cambio * 100) / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: valuta, maximumFractionDigits: 2, minimumFractionDigits: cifra % 1 === 0 ? 0 : 2 }).format(cifra); }
    catch (e) { return '€' + importo; }
  }

  /**
   * Monta le opzioni dentro `contenitore`.
   *   opzioni.form        il modulo «aggiungi al carrello» del tema (obbligatorio)
   *   opzioni.lingua      predefinita: Shopify.locale
   *   opzioni.varianti    [{ id, title }] del prodotto, per le condizioni e il moltiplicatore sulla variante
   *   opzioni.dopo        funzione chiamata dopo l'aggiunta al carrello (predefinito: va a /cart)
   *   opzioni.inCorso     funzione(true|false): l'aggiunta fatta dal widget inizia / finisce (anche con errore)
   *   opzioni.dataConsegna  funzione → 'AAAA-MM-GG' della consegna scelta dal cliente (o '' se non si sa):
   *                       serve alle opzioni con `oraLimiteOggi`. Il tema la legge dal suo calendario.
   *   opzioni.adesso      funzione → { data, minuti } a Roma (predefinito: l'orologio; nelle prove, un orologio finto)
   */
  function monta(contenitore, config, opzioni) {
    opzioni = opzioni || {};
    var form = opzioni.form;
    var lingua = opzioni.lingua || (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'it';
    var stato = { valori: {}, variante: null, quantita: 1, dataConsegna: '', adesso: null };
    var conOraLimite = (config.opzioni || []).some(function (o) { return oraLimite(o) != null; });
    function leggiOrologio() {
      if (!conOraLimite) return;
      stato.adesso = opzioni.adesso ? opzioni.adesso() : oraRomaAdesso();
      try { stato.dataConsegna = opzioni.dataConsegna ? String(opzioni.dataConsegna() || '') : ''; } catch (e) { stato.dataConsegna = ''; }
    }
    var foto = {}; // id opzione → File[]
    // 29/10/2026 («Modifica» dal carrello): le foto già caricate in un giro precedente, [[nome proprietà, url]] per
    // opzione. Non si possono riaprire come file: viaggiano come proprietà (l'url del CDN) e contano nel prezzo.
    var tenute = {};
    var ridisegni = {}; // id opzione → funzione che ridisegna l'album
    var avvisiFoto = []; // «Foto non aggiunta…»: valgono per l'ultima scelta, non per lo stato
    function pulisciAvvisiFoto() { avvisiFoto.forEach(function (a) { a.textContent = ''; }); }
    var blocchi = {};
    var toccate = {};
    // ⚠️ Mai `form.id`: nei moduli di Shopify c'è sempre un campo name="id" (la variante), e `form.id` restituisce
    // quel campo, non l'attributo. I campi collegati finivano con form="[object HTMLSelectElement]" e non partivano.
    if (!form.getAttribute('id')) form.setAttribute('id', 'deluxy-opzioni-form-' + Math.random().toString(36).slice(2, 8));
    var idForm = form.getAttribute('id');
    var idRiga = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    var m = function (chiave, n) { return messaggio(chiave, lingua, n); };
    var uid = function (o, coda) { return 'dxo-' + o.id + (coda ? '-' + coda : ''); };

    function leggiTema() {
      var campoId = form.querySelector('[name="id"]');
      var id = campoId ? String(campoId.value) : null;
      var v = (opzioni.varianti || []).filter(function (x) { return String(x.id) === id; })[0];
      stato.variante = v ? { id: v.id, titolo: v.title } : null;
      var q = form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + idForm + '"]');
      stato.quantita = q ? Math.max(1, Number(q.value) || 1) : 1;
    }

    // Un prezzo che si moltiplica dice la sua unità: «+0,50 € l'una», non «+0,50 €» come fosse fisso.
    function etichettaPrezzo(p) {
      if (!p || !(Number(p.importo) > 0)) return '';
      var unita = p.per === 'valore' || p.per === 'foto' ? ' ' + m('l_una') : p.per === 'variante' ? ' ' + m('a_porzione') : '';
      return ' (+' + denaro(Number(p.importo)) + unita + ')';
    }

    function costruisci(o) {
      var nome = testo(o.nome, lingua);
      var idErrore = uid(o, 'errore');
      var corpo;
      // Toccare un'opzione toglie gli avvisi delle foto scartate (D6, 28/10/2026): restavano lì con le foto ormai a posto.
      var cambia = function (v) { stato.valori[o.id] = v; toccate[o.id] = true; if (o.tipo !== 'foto') pulisciAvvisiFoto(); aggiorna(); };
      if (o.tipo === 'testo' || o.tipo === 'numero' || o.tipo === 'testo_lungo') {
        // 28/10/2026 (D7): niente `maxlength`, che tagliava in silenzio «UNO DUE TRE» in «UNO DUE TR». Oltre il massimo
        // il testo resta com'è, il contatore lo dice e `valida` ferma l'acquisto con «Al massimo 10 caratteri».
        var conta = o.tipo !== 'numero' && o.max != null ? el('span', { class: 'dxo-conta', id: uid(o, 'conta') }) : null;
        var campo = el(o.tipo === 'testo_lungo' ? 'textarea' : 'input', {
          id: uid(o), class: 'dxo-campo', type: o.tipo === 'testo_lungo' ? null : 'text', inputmode: o.tipo === 'numero' ? 'numeric' : null,
          rows: o.tipo === 'testo_lungo' ? 3 : null,
          'aria-describedby': idErrore + (conta ? ' ' + uid(o, 'conta') : ''), 'aria-required': o.obbligatoria ? 'true' : null, autocomplete: 'off',
        });
        var contaAggiorna = function () { if (conta) conta.textContent = campo.value.length + '/' + o.max; };
        campo.addEventListener('input', function () { contaAggiorna(); cambia(campo.value); });
        contaAggiorna();
        corpo = conta ? el('div', { class: 'dxo-con-conta' }, [campo, conta]) : campo;
      } else if (o.tipo === 'scelta' && o.aspetto === 'tendina' && !o.multipla) {
        corpo = el('select', { id: uid(o), class: 'dxo-campo', 'aria-describedby': idErrore, 'aria-required': o.obbligatoria ? 'true' : null },
          [el('option', { value: '', text: m('scegli') + '…' })].concat((o.valori || []).map(function (v) {
            return el('option', { value: v.id, text: testo(v.nome, lingua) + etichettaPrezzo(v.prezzo) });
          })));
        corpo.addEventListener('change', function () { cambia(corpo.value); });
      } else if (o.tipo === 'scelta') {
        corpo = el('div', { class: 'dxo-scelte dxo-scelte--' + (o.aspetto || 'pulsanti'), role: o.multipla ? 'group' : 'radiogroup', 'aria-labelledby': uid(o, 'nome'), 'aria-describedby': idErrore, 'aria-required': !o.multipla && o.obbligatoria ? 'true' : null });
        (o.valori || []).forEach(function (v) {
          var input = el('input', { type: o.multipla ? 'checkbox' : 'radio', name: uid(o, 'scelta'), value: v.id, id: uid(o, v.id), class: 'dxo-nascosto', form: 'dxo-fuori-dal-modulo' });
          var dentro = [];
          if (o.aspetto === 'immagini' && v.immagine && immagineAmmessa(v.immagine)) dentro.push(el('img', { src: v.immagine, alt: '', loading: 'lazy', width: 72, height: 72 }));
          if (o.aspetto === 'colori' && v.colore && coloreAmmesso(v.colore)) { var c = el('span', { class: 'dxo-colore' }); c.style.background = v.colore; dentro.push(c); }
          dentro.push(el('span', { text: testo(v.nome, lingua) + etichettaPrezzo(v.prezzo) }));
          corpo.appendChild(input);
          corpo.appendChild(el('label', { for: uid(o, v.id), class: 'dxo-pillola' }, dentro));
          input.addEventListener('change', function () {
            var scelti = Array.prototype.slice.call(corpo.querySelectorAll('input:checked')).map(function (i) { return i.value; });
            cambia(o.multipla ? scelti : scelti[0] || '');
          });
          // Una scelta singola non obbligatoria si può togliere ricliccandola.
          if (!o.multipla && !o.obbligatoria) input.addEventListener('click', function () {
            if (stato.valori[o.id] === v.id && input.dataset.era === '1') { input.checked = false; input.dataset.era = ''; cambia(''); }
            else { Array.prototype.forEach.call(corpo.querySelectorAll('input'), function (i) { i.dataset.era = ''; }); input.dataset.era = '1'; }
          });
        });
      } else if (o.tipo === 'foto') {
        foto[o.id] = [];
        tenute[o.id] = [];
        var scelta = el('input', { type: 'file', id: uid(o), accept: 'image/jpeg,image/png,image/webp,.heic,.heif', multiple: (o.max == null || o.max > 1) ? true : null, class: 'dxo-nascosto', 'aria-describedby': idErrore, 'aria-required': o.obbligatoria || o.min > 0 ? 'true' : null });
        var griglia = el('div', { class: 'dxo-album', 'aria-live': 'polite' });
        var avviso = el('p', { class: 'dxo-errore', role: 'alert' });
        avvisiFoto.push(avviso);
        var quante = function () { return tenute[o.id].length + foto[o.id].length; };
        var ridisegna = function () {
          griglia.textContent = '';
          // Prima le foto già nel carrello (dalla «Modifica»): si vedono dal CDN e si possono togliere.
          tenute[o.id].forEach(function (t, i) {
            var img = el('img', { alt: t[0], width: 72, height: 72, src: immagineAmmessa(t[1]) ? t[1] : '' });
            var via = el('button', { type: 'button', class: 'dxo-togli', 'aria-label': m('togli') + ' ' + t[0], text: '×' });
            via.addEventListener('click', function () { avviso.textContent = ''; tenute[o.id].splice(i, 1); ridisegna(); cambia(quante()); });
            griglia.appendChild(el('div', { class: 'dxo-foto dxo-foto--tenuta' }, [img, via]));
          });
          foto[o.id].forEach(function (f, i) {
            var img = el('img', { alt: f.name, width: 72, height: 72 });
            img.src = URL.createObjectURL(f);
            img.onload = function () { URL.revokeObjectURL(img.src); };
            var via = el('button', { type: 'button', class: 'dxo-togli', 'aria-label': m('togli') + ' ' + f.name, text: '×' });
            via.addEventListener('click', function () { avviso.textContent = ''; foto[o.id].splice(i, 1); ridisegna(); cambia(quante()); });
            griglia.appendChild(el('div', { class: 'dxo-foto' }, [img, via]));
          });
        };
        ridisegni[o.id] = ridisegna;
        var accogli = function (lista) {
          avviso.textContent = '';
          Array.prototype.forEach.call(lista, function (f) {
            if (!/^image\/(jpeg|png|webp|heic|heif)$/.test(f.type) && !/\.(heic|heif)$/i.test(f.name)) { avviso.textContent = m('foto_tipo'); return; }
            if (f.size > PESO_MAX_MB * 1024 * 1024) { avviso.textContent = m('foto_peso', PESO_MAX_MB); return; }
            if (o.max != null && quante() >= o.max) { avviso.textContent = m('foto_scartata', o.max); return; }
            foto[o.id].push(f);
          });
          ridisegna();
          cambia(quante());
        };
        scelta.addEventListener('change', function () { accogli(scelta.files); scelta.value = ''; });
        var bottone = el('label', { for: uid(o), class: 'dxo-pillola dxo-carica', text: '+ ' + m('aggiungi_foto') + (o.max > 1 ? ' (' + m('max_breve', o.max) + ')' : '') });
        var zona = el('div', { class: 'dxo-zona', role: 'group', 'aria-labelledby': uid(o, 'nome') }, [scelta, bottone, griglia, avviso]);
        zona.addEventListener('dragover', function (e) { e.preventDefault(); });
        zona.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer) accogli(e.dataTransfer.files); });
        corpo = zona;
      }
      var gruppo = (o.tipo === 'scelta' && o.aspetto !== 'tendina') || o.tipo === 'foto';
      var etichetta = el(gruppo ? 'span' : 'label', { class: 'dxo-nome', id: uid(o, 'nome'), for: gruppo ? null : uid(o) }, [
        document.createTextNode(nome + etichettaPrezzo(o.prezzo)),
        o.obbligatoria || ((o.tipo === 'foto' || o.multipla) && o.min > 0) ? el('span', { class: 'dxo-obbligo', 'aria-hidden': 'true', text: ' *' }) : null,
      ]);
      var blocco = el('div', { class: 'dxo-opzione', 'data-opzione': o.id }, [
        etichetta,
        testo(o.aiuto, lingua) ? el('p', { class: 'dxo-aiuto', text: testo(o.aiuto, lingua) }) : null,
        // «Per oggi entro le 13:00»: `aggiorna()` lo cambia in avviso quando l'ora è passata e la consegna è oggi.
        oraLimite(o) != null ? el('p', { class: 'dxo-aiuto dxo-ora-limite', text: m('ora_limite', etichettaOra(oraLimite(o))) }) : null,
        // 27/10/2026 (custode UX): il limite di parole si dice PRIMA di superarlo; `aggiorna()` mostra la riga solo
        // quando vale per la porzione scelta (`maxParoleSe`).
        o.maxParole != null ? el('p', { class: 'dxo-aiuto dxo-max-parole', text: m('max_parole', o.maxParole) }) : null,
        corpo,
        el('p', { class: 'dxo-errore dxo-errore-campo', id: idErrore, role: 'alert' }),
      ]);
      blocchi[o.id] = blocco;
      return blocco;
    }

    var riepilogo = el('p', { class: 'dxo-totale', 'aria-live': 'polite' });
    // Stato dell'invio ed errore del carrello: elementi propri, che `aggiorna()` non riscrive.
    var statoInvio = el('p', { class: 'dxo-aiuto', role: 'status' });
    var erroreCarrello = el('p', { class: 'dxo-errore', role: 'alert' });
    var nascosti = el('div', { class: 'dxo-nascosto' });

    function aggiorna(mostraTutti) {
      leggiTema();
      leggiOrologio();
      var errori = {};
      valida(config, stato, lingua).forEach(function (e) { errori[e.id] = e.messaggio; });
      config.opzioni.forEach(function (o) {
        var b = blocchi[o.id];
        var siVede = visibile(o, config, stato);
        b.hidden = !siVede;
        // Fuori orario per oggi: i campi si spengono e la riga sotto il nome diventa l'avviso.
        if (oraLimite(o) != null) {
          var fuori = fuoriOrario(o, stato);
          var nota = b.querySelector('.dxo-ora-limite');
          if (nota) { nota.textContent = m(fuori ? 'fuori_orario' : 'ora_limite', etichettaOra(oraLimite(o))); nota.classList.toggle('dxo-errore', fuori); }
          Array.prototype.forEach.call(b.querySelectorAll('input:not([type=hidden]), select, textarea, label.dxo-pillola'), function (campo) {
            if (campo.tagName === 'LABEL') campo.classList.toggle('dxo-pillola--spenta', fuori);
            else campo.disabled = fuori;
          });
          b.classList.toggle('dxo-opzione--fuori-orario', fuori);
        }
        if (o.maxParole != null) {
          var notaParole = b.querySelector('.dxo-max-parole');
          if (notaParole) notaParole.hidden = !(!o.maxParoleSe || vera(o.maxParoleSe, config, stato, [o.id]));
        }
        var p = b.querySelector('.dxo-errore-campo');
        var mostra = siVede && errori[o.id] && (mostraTutti || toccate[o.id]);
        p.textContent = mostra ? errori[o.id] : '';
        b.classList.toggle('dxo-opzione--errore', !!mostra);
        var bersaglio = b.querySelector('.dxo-campo, .dxo-scelte, .dxo-zona');
        if (bersaglio) { if (mostra) bersaglio.setAttribute('aria-invalid', 'true'); else bersaglio.removeAttribute('aria-invalid'); }
      });
      var esito = calcola(config, stato);
      riepilogo.textContent = esito.totale > 0 ? m('totale') + ': +' + denaro(esito.totale) : '';
      // I campi che il modulo del tema porta nel carrello: proprietà in italiano. Le foto no: le aggiunge `invia`.
      nascosti.textContent = '';
      esito.proprieta.forEach(function (p) { nascosti.appendChild(el('input', { type: 'hidden', name: 'properties[' + p[0] + ']', value: p[1], form: idForm })); });
      // Le foto tenute dal carrello (29/10/2026): già sul CDN, viaggiano come proprietà col loro nome di prima.
      config.opzioni.forEach(function (o) {
        if (o.tipo !== 'foto' || !visibile(o, config, stato)) return;
        (tenute[o.id] || []).forEach(function (t) { nascosti.appendChild(el('input', { type: 'hidden', name: 'properties[' + t[0] + ']', value: t[1], form: idForm })); });
      });
      if (esito.plus.length) nascosti.appendChild(el('input', { type: 'hidden', name: 'properties[_plus_id]', value: idRiga, form: idForm }));
      return { errori: errori, esito: esito };
    }

    /**
     * Le foto scelte, coi nomi delle proprietà: [[«Polaroid 1», File]]. 28/10/2026 (D1): prima viaggiavano come campi
     * file nascosti del modulo, ma senza plus a pagamento il modulo lo mandava il tema, url-encoded, e le foto
     * gratuite si perdevano in silenzio. Ora, con almeno una foto, l'invio lo fa sempre il widget (FormData).
     * 29/10/2026: le nuove si numerano dopo quelle tenute dal carrello («Polaroid 1» tenuta → la nuova è «Polaroid 2»).
     */
    function fotoDaInviare() {
      var lista = [];
      config.opzioni.forEach(function (o) {
        if (o.tipo !== 'foto' || !visibile(o, config, stato)) return;
        var nome = chiave(o.nome);
        var gia = (tenute[o.id] || []).length;
        foto[o.id].forEach(function (f, i) { lista.push([nome + (gia + foto[o.id].length > 1 || o.max > 1 ? ' ' + (gia + i + 1) : ''), f]); });
      });
      return lista;
    }

    /**
     * 29/10/2026 — «Modifica» dal carrello: rimette nel widget le proprietà di una riga già nel carrello
     * ({ 'Scritta sulla torta': 'Auguri', 'Candelina': '21', 'Polaroid 1': 'https://cdn…' }). I testi e i numeri
     * tornano nei campi, le scelte si riaccendono dal nome italiano, le foto restano come url (vedi `tenute`).
     * Le proprietà che non corrispondono a nessuna opzione si ignorano. Poi `aggiorna()`.
     */
    function precompila(proprieta) {
      proprieta = proprieta || {};
      config.opzioni.forEach(function (o) {
        var b = blocchi[o.id];
        if (!b) return;
        // La riga può avere la chiave nuova (inglese) o quella di prima del 29/10 (italiana).
        var nomi = [chiave(o.nome), testo(o.nome, 'it')];
        var nome = nomi.filter(function (n) { return proprieta[n] != null; })[0] || nomi[0];
        if (o.tipo === 'foto') {
          var lista = [];
          Object.keys(proprieta).forEach(function (k) {
            var v = String(proprieta[k] || '');
            var mio = nomi.some(function (n) { return n && (k === n || (k.indexOf(n + ' ') === 0 && /^\d+$/.test(k.slice(n.length + 1)))); });
            if (mio && /\/uploads\//.test(v)) lista.push([k, v]);
          });
          if (!lista.length) return;
          tenute[o.id] = lista;
          stato.valori[o.id] = lista.length + foto[o.id].length;
          if (ridisegni[o.id]) ridisegni[o.id]();
          return;
        }
        var v = proprieta[nome];
        if (v == null || String(v).trim() === '') return;
        v = String(v);
        if (o.tipo === 'scelta') {
          var parti = v.split(', ').map(function (x) { return x.trim().toLowerCase(); });
          var ids = (o.valori || []).filter(function (x) { return parti.indexOf(chiave(x.nome).trim().toLowerCase()) >= 0 || parti.indexOf(testo(x.nome, 'it').trim().toLowerCase()) >= 0; }).map(function (x) { return x.id; });
          if (!ids.length) return;
          var tendina = b.querySelector('select');
          if (tendina) { tendina.value = ids[0]; tendina.dispatchEvent(new Event('change', { bubbles: true })); return; }
          Array.prototype.forEach.call(b.querySelectorAll('input[type=radio], input[type=checkbox]'), function (i) {
            i.checked = ids.indexOf(i.value) >= 0;
            if (i.checked) i.dataset.era = '1';
          });
          var primo = b.querySelector('input[type=radio], input[type=checkbox]');
          if (primo) primo.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        var campo = b.querySelector('input.dxo-campo, textarea.dxo-campo');
        if (!campo) return;
        campo.value = v;
        campo.dispatchEvent(new Event('input', { bubbles: true }));
      });
      aggiorna();
    }

    config.opzioni.forEach(function (o) {
      contenitore.appendChild(costruisci(o));
      // La scelta già fatta in partenza («Personalizza con foto: NO»).
      if (o.tipo === 'scelta' && o.predefinito && !o.multipla) {
        stato.valori[o.id] = o.predefinito;
        var campo = blocchi[o.id].querySelector('select');
        if (campo) campo.value = o.predefinito;
        var tondo = document.getElementById(uid(o, o.predefinito));
        if (tondo) { tondo.checked = true; tondo.dataset.era = '1'; }
      }
    });
    contenitore.appendChild(riepilogo);
    contenitore.appendChild(statoInvio);
    contenitore.appendChild(erroreCarrello);
    contenitore.appendChild(nascosti);
    contenitore.classList.add('dxo');

    // 28/10/2026 (D5): sul telefono il blocco del tema che contiene il widget è la barra fissa in basso («ACQUISTA»),
    // e con le opzioni dentro arrivava a coprire metà schermo. Se un antenato è `position: fixed` il widget esce e
    // si mette subito prima di quell'antenato, nel flusso della pagina; quando la barra torna normale (desktop) rientra
    // al suo posto. Funziona perché ogni campo che va al carrello è legato al modulo con l'attributo `form`.
    var segnaposto = document.createComment('deluxy-opzioni');
    contenitore.parentNode.insertBefore(segnaposto, contenitore);
    function antenatoFisso(nodo) {
      for (var n = nodo && nodo.parentElement; n && n !== document.body; n = n.parentElement) {
        if (getComputedStyle(n).position === 'fixed') return n;
      }
      return null;
    }
    function sistemaPosto() {
      var fisso = antenatoFisso(segnaposto);
      if (fisso && fisso.parentNode && contenitore.nextSibling !== fisso) fisso.parentNode.insertBefore(contenitore, fisso);
      else if (!fisso && contenitore.previousSibling !== segnaposto) segnaposto.parentNode.insertBefore(contenitore, segnaposto.nextSibling);
    }
    sistemaPosto();
    var attesaPosto;
    // Anche allo scorrimento: una barra può diventare fissa per classe solo quando si scorre.
    var ricontrollaPosto = function () { clearTimeout(attesaPosto); attesaPosto = setTimeout(sistemaPosto, 150); };
    window.addEventListener('resize', ricontrollaPosto);
    window.addEventListener('scroll', ricontrollaPosto, { passive: true });

    form.addEventListener('change', function () { aggiorna(); });
    // L'ora passa e la data si sceglie fuori dal modulo (calendario del tema, localStorage): si riguarda ogni
    // minuto e quando la pagina torna in primo piano. Solo se qualche opzione ha un'ora limite.
    if (conOraLimite) {
      setInterval(function () { aggiorna(); }, 60000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) aggiorna(); });
      window.addEventListener('storage', function () { aggiorna(); });
      document.addEventListener('deluxy:consegna', function () { aggiorna(); });
    }
    var inInvio = false;
    // In cattura: prima del tema. Se manca qualcosa si ferma tutto; se ci sono plus a pagamento o foto
    // l'aggiunta la facciamo noi (riga madre coi file, poi le righe dei plus collegate).
    form.addEventListener('submit', function (evento) {
      if (inInvio) return;
      erroreCarrello.textContent = '';
      pulisciAvvisiFoto();
      var r = aggiorna(true);
      var primo = config.opzioni.filter(function (o) { return r.errori[o.id] && visibile(o, config, stato); })[0];
      if (primo) {
        evento.preventDefault(); evento.stopImmediatePropagation();
        var b = blocchi[primo.id];
        var fuoco = b.querySelector('input:not([type=hidden]), select, textarea');
        if (fuoco) fuoco.focus();
        b.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var fotoScelte = fotoDaInviare();
      // Niente a pagamento e niente foto: il tema fa da sé, coi campi già nel modulo.
      if (!r.esito.plus.length && !fotoScelte.length) return;
      // Un plus scelto senza variante sul negozio: si ferma TUTTO, la torta non entra da sola (27/10/2026).
      var senzaVariante = plusSenzaVariante(r.esito);
      if (senzaVariante.length) {
        evento.preventDefault(); evento.stopImmediatePropagation();
        erroreCarrello.textContent = m('plus_non_disponibile');
        erroreCarrello.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (window.console) console.warn('Deluxy Opzioni: plus senza variante sul negozio', senzaVariante.map(function (p) { return p.sku; }));
        return;
      }
      evento.preventDefault(); evento.stopImmediatePropagation();
      inInvio = true;
      // 29/10/2026: il tema sa che l'aggiunta è in corso (tiene ACQUISTA spento con la rotellina finché non finiamo).
      if (opzioni.inCorso) { try { opzioni.inCorso(true); } catch (e) {} }
      erroreCarrello.textContent = '';
      statoInvio.textContent = m('invio');
      form.setAttribute('aria-busy', 'true');
      var bottoni = form.querySelectorAll('[type=submit]');
      Array.prototype.forEach.call(bottoni, function (x) { x.disabled = true; });
      var titolo = opzioni.titolo || document.title;
      var chiaveMadre = null;
      var dati = new FormData(form);
      fotoScelte.forEach(function (x) { dati.append('properties[' + x[0] + ']', x[1], x[1].name); });
      // `/cart/add.js` senza prefisso di lingua: risponde nella lingua del negozio (italiano), da cui `product_title`.
      fetch('/cart/add.js', { method: 'POST', body: dati, headers: { Accept: 'application/json' } })
        .then(function (risposta) { if (!risposta.ok) throw new Error('madre'); return risposta.json(); })
        .then(function (madre) {
          chiaveMadre = madre && madre.key;
          if (!r.esito.plus.length) return { ok: true };
          // 28/10/2026 (D4): «Per» è una proprietà, quindi in italiano; il titolo della pagina /ru era «Краны».
          if (madre && madre.product_title) titolo = madre.product_title;
          var righe = r.esito.plus.map(function (p) {
            var proprieta = { _plus_di: idRiga, _plus_codice: p.codice, For: titolo };
            p.voci.forEach(function (v) { var i = v.indexOf(': '); proprieta[v.slice(0, i)] = v.slice(i + 2); });
            return { id: p.variante, quantity: p.quantita, properties: proprieta };
          });
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: righe }) });
        })
        .then(function (risposta) {
          if (!risposta.ok) throw new Error('plus');
          if (opzioni.dopo) opzioni.dopo(); else window.location.href = '/cart';
        })
        .catch(function (errore) {
          // La madre è entrata e i plus no: si toglie la madre appena aggiunta (28/10/2026: prima restava, con la
          // scritta e senza il supplemento pagato), così il cliente riprova da capo.
          // Si decide sulla fase (madre entrata), non sul messaggio: anche una rete caduta sulla seconda chiamata ripulisce.
          var pulizia = chiaveMadre && r.esito.plus.length
            ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: chiaveMadre, quantity: 0 }) }).then(riallineaCarrello)
            : Promise.resolve();
          // Anche se la pulizia fallisce (rete caduta) l'errore si dice lo stesso.
          return pulizia.catch(function () {}).then(function () { erroreCarrello.textContent = m('errore_carrello'); });
        })
        .then(function () {
          // Ogni tentativo ha un `_plus_id` nuovo: un residuo di un tentativo fallito non si fonde mai con il successivo.
          idRiga = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
          inInvio = false;
          statoInvio.textContent = '';
          form.removeAttribute('aria-busy');
          Array.prototype.forEach.call(bottoni, function (x) { x.disabled = false; });
          if (opzioni.inCorso) { try { opzioni.inCorso(false); } catch (e) {} }
          aggiorna();
        });
    }, true);

    aggiorna();
    return { aggiorna: aggiorna, stato: stato, precompila: precompila };
  }

  /** Toglie dal carrello i plus rimasti senza la loro riga madre. Da chiamare nella pagina e nel cassetto del carrello. */
  function riallineaCarrello() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (carrello) {
      var via = orfane(carrello);
      if (!via.length) return false;
      var aggiornamenti = {};
      via.forEach(function (x) { aggiornamenti[x.key] = 0; });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: aggiornamenti }) }).then(function () { return true; });
    });
  }

  puro.monta = monta;
  puro.riallineaCarrello = riallineaCarrello;
  return puro;
});
